export type NotificationIntegrationErrorCode =
  | 'notification-integration.completion-failed'
  | 'notification-integration.invalid-config'
  | 'notification-integration.not-found'
  | 'notification-configuration.user-event-not-supported';

export type PerkIntegrationErrorCode =
  | 'perk-integration.disabled'
  | 'perk-integration.invalid-access-data'
  | 'perk-integration.invalid-config'
  | 'perk-integration.invalid-exposed-usage-data'
  | 'perk-integration.invalid-internal-usage-data'
  | 'perk-integration.invalid-state'
  | 'perk-integration.invalid-usage-input-data'
  | 'perk-integration.not-found';

export type TriggerIntegrationErrorCode =
  | 'trigger-integration.completion-failed'
  | 'trigger-integration.disabled'
  | 'trigger-integration.invalid-config'
  | 'trigger-integration.invalid-verification-attempt-data'
  | 'trigger-integration.not-found';

export type RuleEngineErrorCode =
  | 'rule.criterion-filter-not-found'
  | 'rule.criterion-not-found'
  | 'rule.criterion-type-mismatch'
  | 'rule.group-not-found'
  | 'rule.invalid-criterion-data'
  | 'rule.not-found'
  | 'rule.not-ready'
  | 'rule.operator-not-found'
  | 'rule.transformer-not-foud';

export type CohortErrorCode =
  | NotificationIntegrationErrorCode
  | PerkIntegrationErrorCode
  | TriggerIntegrationErrorCode
  | RuleEngineErrorCode
  | 'alchemy.invalid-webhook'
  | 'api-key.not-found'
  | 'app.credentials-invalid'
  | 'app.credentials-not-found'
  | 'app.external-service-error'
  | 'app.installation-error'
  | 'app.insufficient-permissions'
  | 'app.merchant-credentials-invalid'
  | 'app.no-merchant-auth'
  | 'app.no-user-auth'
  | 'app.not-found'
  | 'app.rate-limit-exceeded'
  | 'app.webhook-processing-error-unretryable'
  | 'app.webhook-processing-error'
  | 'app.webhook-validation-error'
  | 'app-action.disabled'
  | 'app-action.invalid-connection'
  | 'app-action.invalid-input'
  | 'app-action.invalid-output'
  | 'app-action.failed'
  | 'app-action.not-found'
  | 'app-action.unauthorized'
  | 'asset.invalid-content-type'
  | 'auth.id-token-expired'
  | 'auth.invalid-auth-token'
  | 'auth.invalid-otp-code'
  | 'auth.invalid-turnstile-token'
  | 'auth.invalid-user'
  | 'auth.unauthorized'
  | 'cohort.invalid-configuration'
  | 'cohort.invalid-type'
  | 'cohort.not-found'
  | 'connection.already-configured'
  | 'connection.in-use'
  | 'connection.invalid-config'
  | 'connection.invalid-type'
  | 'connection.not-found'
  | 'connector.invalid-type'
  | 'connector.not-found'
  | 'blockchain.invalid-network'
  | 'blockchain.missing-contract-address'
  | 'blockchain-tx-request.invalid-gas-limit'
  | 'blockchain-tx-request.invalid-status'
  | 'blockchain-tx-request.mined-tx-not-found'
  | 'blockchain-tx-request.not-found'
  | 'campaign.already-exists'
  | 'campaign.already-published'
  | 'campaign.ended'
  | 'campaign.invalid-configuration'
  | 'campaign.invalid-currency'
  | 'campaign.invalid-pricing'
  | 'campaign.invalid-type'
  | 'campaign.not-enough-tokens'
  | 'campaign.not-found'
  | 'campaign.not-publishable'
  | 'campaign.not-published'
  | 'campaign.order-session-expired'
  | 'campaign.redeem-code-missing'
  | 'campaign.tokens-not-available'
  | 'campaign.user-not-in-cohort'
  | 'currency-spec.not-found'
  | 'collection.not-found'
  | 'country-spec.not-found'
  | 'digital-asset.not-found'
  | 'digital-asset-collection.blockchain-tx-request-already-set'
  | 'digital-asset-collection.invalid-status'
  | 'digital-asset-collection.max-ownerships-reached'
  | 'digital-asset-collection.nft-not-enabled'
  | 'digital-asset-collection.not-deployed'
  | 'digital-asset-collection.not-found'
  | 'digital-asset-collection.smart-contract-already-set'
  | 'digital-asset.already-minted'
  | 'digital-asset.blockchain-tx-request-already-set'
  | 'digital-asset.invalid-input-data'
  | 'digital-asset.not-found'
  | 'digital-asset.not-minted'
  | 'digital-asset.token-not-available'
  | 'generic.invalid-request'
  | 'generic.translation-not-found'
  | 'healthcheck.postgres-error'
  | 'healthcheck.redis-error'
  | 'infra.pubsub-error'
  | 'instagram.member-handle-not-found'
  | 'journey.not-found'
  | 'journey.cohort-not-found'
  | 'journey-participation.already-completed'
  | 'journey-participation.not-completed'
  | 'journey-participation.not-found'
  | 'journey-step-completion.already-completed'
  | 'journey-step-completion.attempt-not-found'
  | 'journey-step-completion.max-attempts-reached'
  | 'journey-step-completion.verification-failed'
  | 'journey-step-trigger.not-found'
  | 'journey-step.invalid-configuration'
  | 'journey-step.locked'
  | 'journey-step.not-found'
  | 'journey-steps.invalid-configuration'
  | 'media.asset-does-not-exist'
  | 'media.invalid-mime-type'
  | 'membership-pass.duplicated-member-handle'
  | 'membership-pass.invalid-member-handle'
  | 'merchant.not-found'
  | 'merchant.not-publishable'
  | 'merchant.invalid-configuration'
  | 'merchant.svix-integration-not-set'
  | 'notification-configuration.already-exists'
  | 'notification-configuration.not-found'
  | 'oauth.access-denied'
  | 'oauth.authorization-code-invalid'
  | 'oauth.authorization-error-retryable'
  | 'oauth.authorization-error-unretryable'
  | 'order.already-minted'
  | 'order.already-processed'
  | 'order.duplicate-user'
  | 'order.not-found'
  | 'order.process-error'
  | 'organization-member.already-active'
  | 'organization-member.already-exists'
  | 'organization-member.not-active'
  | 'organization-member.not-found'
  | 'organization.invalid-slug'
  | 'organization.is-live'
  | 'organization.not-found'
  | 'ownership.campaign-or-digital-asset-collection-not-found'
  | 'ownership.invalid-status'
  | 'ownership.not-found'
  | 'ownership.transfer-job-not-found'
  | 'payment-session.not-found'
  | 'perk.already-published'
  | 'perk.invalid-configuration'
  | 'perk.invalid-type'
  | 'perk.invalid-max-usages-per-token'
  | 'perk.invalid-usage-data'
  | 'perk.is-archived'
  | 'perk.not-found'
  | 'perk.not-published'
  | 'perk.usages-limit-reached'
  | 'perk-access.not-found'
  | 'perk-usage.not-found'
  | 'qr-code.expired'
  | 'qr-code.invalid-code'
  | 'qr-code.invalid-ownership'
  | 'qr-code.invalid-perk-type'
  | 'qr-code.invalid-reader'
  | 'qr-code.token-already-used'
  | 'qr-reader.not-found'
  | 'raffle.invalid-status'
  | 'raffle.not-enough-participants'
  | 'redeem-code.code-invalid'
  | 'redeem-code.not-found'
  | 'shopify.app-name-already-exists'
  | 'shopify.app-not-found'
  | 'shopify.shop-not-found'
  | 'smart-contract.missing-address'
  | 'smart-contract.missing-version'
  | 'store.not-found'
  | 'stripe.connect-account-already-exists'
  | 'stripe.connect-account-already-live'
  | 'stripe.connect-account-country-not-available'
  | 'stripe.connect-account-does-not-exist'
  | 'stripe.connect-account-not-found'
  | 'stripe.connect-account-not-live'
  | 'team.invitation.code-not-found'
  | 'team.invitation.expired'
  | 'transfer-invitation.not-active'
  | 'transfer-invitation.not-found'
  | 'transfer.already-transferred'
  | 'transfer.invalid-recipient'
  | 'transfer.invalid-validation-code'
  | 'transfer.not-found'
  | 'user.invalid-auth-token-creation-data'
  | 'user.invalid-language'
  | 'user.invalid-subscription-date'
  | 'user.not-found'
  | 'user.wallet-already-set'
  | 'user-attribute.invalid-value'
  | 'user-event.not-found'
  | 'user-property.not-found'
  | 'users-sync.disabled'
  | 'user-property.controlled-by-user-sync'
  | 'user-property.referenceId-already-exists'
  | 'users-sync.not-found'
  | 'users-sync-integration.not-found'
  | 'wallet.not-found'
  | 'webhook.disabled';

export const authErrors: Array<CohortErrorCode> = [
  'auth.unauthorized',
  'auth.id-token-expired',
  'auth.invalid-user',
];

export class CohortError extends Error {
  public code: CohortErrorCode;
  public context: Record<string, unknown>;

  public constructor(code: CohortErrorCode, context: Record<string, unknown> = {}) {
    super(code);
    this.name = 'CohortError';
    this.code = code;
    this.context = context;
  }
}
